'use client'

import { useUserEntity } from '@entities/users'
import { useEffect } from 'react'

import { useI18n } from './provider'

export const UserLocaleBootstrap = () => {
  const userInfo = useUserEntity()
  const { setLanguageCode } = useI18n()

  useEffect(() => {
    if (userInfo?.languageCode) {
      setLanguageCode(userInfo.languageCode)
    }
  }, [setLanguageCode, userInfo?.languageCode])

  return null
}
